import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  inputDiscardApi,
  type CreateInputDiscardRequestDto,
  type ApproveInputDiscardRequestDto,
} from "../services/inputDiscardApi";

export const useInputDiscardPending = () =>
  useQuery({
    queryKey: ["input-discard", "pending"],
    queryFn: inputDiscardApi.getPending,
  });

export const useInputDiscardApproved = () =>
  useQuery({
    queryKey: ["input-discard", "approved"],
    queryFn: inputDiscardApi.getApproved,
  });

export const useCreateInputDiscard = () =>
  useMutation({
    mutationFn: (dto: CreateInputDiscardRequestDto) => inputDiscardApi.create(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["input-discard"] });
      queryClient.invalidateQueries({ queryKey: ["input-batches"] });
      queryClient.invalidateQueries({ queryKey: ["seed-batch"] });
    },
  });

export const useApproveInputDiscard = () =>
  useMutation({
    mutationFn: ({ id, dto }: { id: string; dto: ApproveInputDiscardRequestDto }) =>
      inputDiscardApi.approve(id, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["input-discard"] });
      queryClient.invalidateQueries({ queryKey: ["input-batches"] });
    },
  });

export const useProcessInputDiscard = () =>
  useMutation({
    mutationFn: (id: string) => inputDiscardApi.process(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["input-discard"] });
      queryClient.invalidateQueries({ queryKey: ["input-batches"] });
      queryClient.invalidateQueries({ queryKey: ["store-inventory"] });
      queryClient.invalidateQueries({ queryKey: ["stock-movements"] });
      queryClient.invalidateQueries({ queryKey: ["seed-batch"] });
    },
  });

export const useApproveAndWriteOff = () =>
  useMutation({
    mutationFn: ({ id, notes }: { id: string; notes?: string }) =>
      inputDiscardApi.approveAndWriteOff(id, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["input-discard"] });
      queryClient.invalidateQueries({ queryKey: ["input-batches"] });
      queryClient.invalidateQueries({ queryKey: ["store-inventory"] });
      queryClient.invalidateQueries({ queryKey: ["stock-movements"] });
      queryClient.invalidateQueries({ queryKey: ["seed-batch"] });
    },
  });
